import { render } from "./Insights.vue?vue&type=template&id=01cfb32c&scoped=true"
import script from "./Insights.vue?vue&type=script&lang=js"
export * from "./Insights.vue?vue&type=script&lang=js"

import "./Insights.vue?vue&type=style&index=0&id=01cfb32c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cfb32c"]])

export default __exports__